import React, { useEffect, Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Box, List, Typography } from '@material-ui/core';

import { useStyles, collapseCardStyles } from './RulesetsWidget.styled';

import i18n from 'i18n-js';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { Card, CollapseCard } from 'components/UI';
import { EditReservationsRulesetsModal } from 'components/Modals';
import { VehiclesGroupsActions } from 'state/modules/vehiclesGroups';
import { reservationRulesetsActions } from 'state/modules/reservationRulesets';

const RulesetsTimes = ({ id }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const collapseCardClasses = collapseCardStyles();
  const [openEditModal, setOpenEditModal] = useState(false);
  const { rrsTimes } = useSelector((state) => state.vehiclesGroups);
  const { localeFormat } = useSelector((state) => state.organizations);

  const handleOpenEditModal = () => {
    setOpenEditModal((prevState) => !prevState);
  };

  /**
   * Vertical menu list
   * It has the label and the function for each action
   */
  const items = [
    {
      title: i18n.t('common.edit'),
      can: { name: 'vehicle_group', action: 'update' },
      onClick: handleOpenEditModal,
    },
  ];

  useEffect(() => {
    dispatch(VehiclesGroupsActions.fetchVehicleGroupsRRStimes(id));
    dispatch(reservationRulesetsActions.fetchReservationRulesets({ is_enabled: true }));
  }, [dispatch, id]);

  return (
    <Card
      menuItems={items}
      headerActionType="vertical"
      data-cy="rrs-times-widget-card"
      title={i18n.t('vehicle_groups.reservations_ruleset')}
    >
      <Box className={classes.cardContentPadding}>
        {rrsTimes?.length > 0 ? (
          <>
            <List className={classes.list}>
              {rrsTimes?.map((val, index) => (
                <Fragment key={index}>
                  <CollapseCard
                    customClasses={collapseCardClasses}
                    title={`${val?.reservation_rules_set?.name} #${val?.reservation_rules_set?.id}`}
                  >
                    <Box display="flex" component="span" flexDirection="row" flexWrap="wrap">
                      {val?.start_time && (
                        <Typography variant="body2" component="span" className={classes.time}>
                          <span>{i18n.t('common.effective_from')}:</span>{' '}
                          <span className={classes.date}>
                            {moment(val?.start_time).format(`${localeFormat} h:mm A`)}
                          </span>
                        </Typography>
                      )}
                      {val?.end_time && (
                        <Typography
                          variant="body2"
                          component="span"
                          color="textSecondary"
                          className={classes.time}
                        >
                          <span>{i18n.t('common.to')}</span>{' '}
                          <span className={classes.date}>
                            {moment(val?.end_time).format(`${localeFormat} h:mm A`)}
                          </span>
                        </Typography>
                      )}
                    </Box>
                  </CollapseCard>
                </Fragment>
              ))}
            </List>
          </>
        ) : (
          <Typography color="textPrimary" style={{ lineHeight: 1 }}>
            <Box fontSize={14} component="span" lineHeight={1}>
              {i18n.t('common.empty_list')}
            </Box>
          </Typography>
        )}
      </Box>
      {openEditModal && (
        <EditReservationsRulesetsModal
          open={true}
          currentVehicleGroup={{ id: id }}
          handleClick={handleOpenEditModal}
        />
      )}
    </Card>
  );
};

export default withRouter(RulesetsTimes);
